export default {
  dark: 'Ciemny',
  light: 'Światło',
};
